namespace TabAurous.Common {
    export interface ExcelGenerateResponse extends Serenity.ServiceResponse {
        Success?: boolean;
    }
}
